<template>
  <div class="home">
    <b-row class="text-center my-4">
      <b-col>
        <img alt="NDEnergy" src="@assets/images/ndenergy.png" height="200" />
      </b-col>
    </b-row>

    <b-row class="justify-content-center my-4">
      <b-col cols="8" md="4">
        <!-- Error Message Area -->
        <b-alert v-model="showMessage" variant="danger">
          {{ loginResult }}
        </b-alert>

        <!-- Username Entry -->
        <b-form-group id="email-input" label-for="email-input">
          <b-form-input id="email-input" v-model="email" placeholder="Please enter your email address or account number"
            required></b-form-input>
        </b-form-group>

        <!-- Password Entry -->
        <b-form-group id="password-input" label-for="password" class="pt-2">
          <b-form-input id="password-input" v-model="password" type="password" placeholder="Password"
            required></b-form-input>
        </b-form-group>

        <!-- Forgot Password (Link) -->
        <p>
          <b><u><a @click="forgotPassword">Forgot your password?</a></u></b>
        </p>

        <!-- Login (Button) -->
        <b-button type="submit" class="my-2 block" variant="danger" :disabled="pageLoading" @click="onSubmit">
          <b-spinner v-if="pageLoading" small class="mr-2 pa-0 my-0"></b-spinner>
          {{ pageLoading ? 'Loading...' : 'Login' }}
        </b-button>

        <!-- Register User (Link) -->
        <p>Don't have an account?
          <b><a @click="registerUser">&nbsp;<u>Register one</u></a></b>
        </p>

        <!-- Select Account Sub-Window -->
        <b-modal id="select-account" title="Select Account" header-bg-variant="light" centered
          @ok="confirmAccountSelected">

          <div v-if="userAccountList.length > 1" class="mb-2"><strong>
              You have {{ userAccountList.length }} account(s) associated with
              this email address. <br />
              Please select one.</strong></div>
          <div v-else class="mb-2"><strong>
              Please confirm the following account information is
              correct.</strong></div>

          <SelectLinkedAccount :useraccounts="userAccountList" @accountSelected="accountSelected" />
          <div class="my-2"><strong> Account not in the list? </strong>
            <u><a @click="registerAccount = true">Register one</a></u>
          </div>

          <RegisterLinkedAccount v-if="registerAccount" :username="email" @successAddAccount="registerSucceed"
            @cancelAddAccount="registerAccount = false" />
        </b-modal>

        <!-- Register Login User Sub-Window -->
        <b-modal id="register-user" title="Register User" header-bg-variant="light" hide-footer centered
          @ok="confirmAccountSelected">
          <RegisterLoginUser />
        </b-modal>

        <!-- Password Reset Sub-Window -->
        <b-modal id="forgot-password" title="Password Reset" header-bg-variant="light" centered hide-footer>
          <PasswordReset @passwordResetCompleted="passwordResetCompleted" />
        </b-modal>
      </b-col>
    </b-row>

    <b-row class="justify-content-center my-4">
      <b-col cols="8" md="4" class="ndfooter">
        <p class="paragraphheight">
          6205A Airport Road, Suite #301, Mississauga, ON L4V 1E1
        </p>
        <p class="paragraphheight">
          Support:
          <a href="mailto: info@ndenergyinc.com">info@ndenergyinc.com</a> | Tel:
          (905) 612-9879 | Fax: (905) 612-0259
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  // reqCheckLegacy,
  reqUserLogin,
  reqUserAccountList,
  // reqPortalUserRefresh,
  // reqPortalAccountSetup,
} from '@services'
import SelectLinkedAccount from '@components/common/CMSelectLinkedAccount'
import RegisterLinkedAccount from '@components/common/CMRegisterLinkedAccount'
import RegisterLoginUser from '@components/common/CMRegisterLoginUser'
import PasswordReset from '@components/common/CMPasswordReset'

export default {
  name: 'Login',
  components: {
    SelectLinkedAccount,
    RegisterLinkedAccount,
    RegisterLoginUser,
    PasswordReset,
  },
  data() {
    return {
      pageLoading: false,
      email: '',
      password: '',

      userAccountList: [],
      registerAccount: false,
      user_uuid: null,
      account_id: null,

      loginResult: '',
    }
  },

  computed: {
    showMessage: function () {
      if (this.loginResult && this.loginResult.trim() !== '') return true
      else return false
    },
  },

  methods: {
    onSubmit() {
      this.pageLoading = true;    // Loading Spinner ON
      this.loginResult = '';      // Clear Error Message

      var accountPrefix = this.email.trim();

      // Account Number Modify
      if (accountPrefix.indexOf('@') === -1) {
        accountPrefix = accountPrefix.replace(new RegExp('-', 'g'), '')
      }

      this.validateAccount();
      // this.pageLoading = false;
    },

    async validateAccount() {
      // Password is blank
      if (this.password.trim() === '') {
        this.loginResult = 'Please enter password.'
        return true
      }

      // Execute User Login
      const result = await reqUserLogin({
        username: this.email.trim(),
        password: this.password.trim(),
      })

      // Success Login
      if (result.status === 'Success') {
        // Save UUID into Local Storage
        this.user_uuid = result.data.user_uuid

        // Get Linked Account List
        const resultAccountList = await reqUserAccountList({
          useruuid: this.user_uuid,
        })

        this.pageLoading = false;    // Loading Spinner OFF

        if (!resultAccountList.data) {
        } else {
          this.userAccountList = resultAccountList.data
          this.$bvModal.show('select-account')
        }
      }

      // Failure Login
      else {
        this.loginResult = result.message
        this.pageLoading = false;    // Loading Spinner OFF
      }
    },

    async registerSucceed() {
      this.registerAccount = false

      const freshResult = await reqUserAccountList({
        useruuid: this.user_uuid,
      })

      if (!freshResult.data) {
        // this.showRegisterAccount = true
        // this.showSelectAccount = false
      } else {
        this.userAccountList = freshResult.data
      }
    },

    // Save Selected Account ID into State
    accountSelected(val) {
      this.account_id = val
    },

    registerUser() {
      this.$bvModal.show('register-user')
    },

    forgotPassword() {
      this.$bvModal.show('forgot-password')
    },

    passwordResetCompleted() {
      this.loginResult = null
      this.email = null
      this.password = null
    },

    async confirmAccountSelected() {
      if (this.account_id) {
        const AccountUuid = this.userAccountList
          .filter((item) => item.account_id === this.account_id)
          .map((item) => item.account_uuid)[0]

        // Save UUID into local storage
        localStorage.setItem('APP_USER_UUID', this.user_uuid)
        localStorage.setItem('APP_ACCOUNT_UUID', AccountUuid)

        this.$store.getters['loginStatus'].then((status) => {
          if (status) {
            this.$router.push('home')
          } else {
            this.$router.push('login')
          }
          this.pageLoading = false;    // Loading Spinner OFF
        })
      }
    },
  },
}
</script>

<style scoped>
.block {
  display: block;
  width: 100%;
  font-size: 16px;
}

.ndfooter {
  padding: 10px 10px 10px 10px;
  font-size: 12px;
  text-align: center;
  background-color: #f1f1f1;
}

.paragraphheight {
  margin-top: 0.2em;
  margin-bottom: 0.2em;
}
</style>
